export enum InvestigationSessionErrorCode {
	ValidationError = "VALIDATION_ERROR",
	SessionNotFound = "SESSION_NOT_FOUND",
	FieldRequired = "FIELD_REQUIRED",
	EndTimeBeforeStartTime = "END_TIME_BEFORE_START_TIME",
	SessionDateNotAllowed = "SESSION_DATE_NOT_ALLOWED",
	InvalidMeetingLink = "INVALID_MEETING_LINK",
	AppointmentUnchanged = "APPOINTMENT_UNCHANGED",
	AnswerRequired = "ANSWER_REQUIRED",
	WorkingDaysOutOfRange = "WORKING_DAYS_OUT_OF_RANGE",
	AttendanceBeforeStart = "ATTENDANCE_BEFORE_START",
	AttachmentsBeforeStart = "ATTACHMENTS_BEFORE_START",
}
